import * as React from 'react';
import * as navigation from 'app/area/shared/navigation';
import { Numberbox } from 'ui';
import { ButtonPrimary } from 'ui/common/button';
import { authProvider } from 'dependencies/auth';
import styles from './open-case-banner.scss';

export interface OpenCaseBannerProps {
  textHeader: string;
  textCaseNo: string;
  textCasePassword: string;
  textOpenCase: string;
}

export interface OpenCaseBannerState {
  caseNumber?: string;
  casePassword?: string;
}

export class OpenCaseBanner extends React.Component<OpenCaseBannerProps, OpenCaseBannerState> {
  constructor(props: OpenCaseBannerProps) {
    super(props);
    authProvider.setAuthorization(undefined);
    this.state = {
      caseNumber: '',
      casePassword: ''
    };
  }

  private get isInteger() {
    const { caseNumber } = this.state;
    return caseNumber.match(/^\d+$/) && caseNumber.length < 17 && Number(caseNumber) <= Number.MAX_SAFE_INTEGER;
  }

  private onChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (event && event.target && event.target.name) {
      this.setState({
        [event.target.name]: event.target.value
      });
    }
  };

  private onChangeNumber = (value: number) => {
    this.setState({ caseNumber: !!value ? String(value) : '' });
  };

  private onOpenCase = (event: any) => {
    event.preventDefault();
    const { caseNumber, casePassword } = this.state;
    if (!!caseNumber && !!casePassword && this.isInteger) {
      authProvider.setAuthorization(casePassword);
      navigation.toCaseEdit(Number(caseNumber));
    }
  };

  public render() {
    const { textHeader, textCaseNo, textCasePassword, textOpenCase } = this.props;
    const { caseNumber, casePassword } = this.state;

    return (
      <div className="container main-grid">
        <div className={styles.openCaseBannerPanel}>
          <h1>{textHeader}</h1>
          <form onSubmit={this.onOpenCase} id="openCase">
            <div className={`${styles.openCaseBannerInputContainer} form-group`}>
                <Numberbox
                  componentId="caseNumber"
                  className={styles.openCaseBannerInput}
                  placeholder={textCaseNo}
                  value={!caseNumber ? undefined : Number(caseNumber)}
                  onChange={this.onChangeNumber}
                  useThousand={false} />
                <div className="input-wrapper">
                  <input
                    id="casePassword"
                    name="casePassword"
                    className={"form-control"}
                    type="password"
                    placeholder={textCasePassword}
                    value={casePassword}
                    onChange={this.onChangeValue} />
                 </div>
              <div className="input-group-btn">
                <ButtonPrimary
                  onClick={this.onOpenCase}
                  id="open_case"
                  disabled={!this.isInteger || !casePassword}
                  className={`btn btn-call-to-action ${styles.btnOpenCase}`}>
                  {textOpenCase}
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
